const Message = ({ notification }) => {
    return (
      <div style={{display:'flex',flexDirection:"column"}}>
        <div id="notificationHeader">
          {notification.image && (
            <div id="imageContainer">
              <img src={notification.image} width={50} />
            </div>
          )}
          <span style={{marginLeft:'4px'}}>{notification.title}</span>
        </div>


        <div id="notificationBody">{notification.body}</div>
      </div>
    );
  };
  
export default Message;